// extracted by mini-css-extract-plugin
module.exports = {"link":"Navigation_link__2_eun","activeLink":"Navigation_activeLink__Mfq4i"};